var axios = require('axios')

import Vue from 'vue'
import main from './main.js'
import apiMenu from './assets/api/Menu.js'
import apiOutlet from './assets/api/Outlet.js'
import apiTenant from './assets/api/Tenant.js'
import apiCoupon from './assets/api/Coupon.js'
import apiOrder from './assets/api/Order.js'
import apiUser from './assets/api/User.js'
import apiCustomer from './assets/api/Customer.js'
import apiCategory from './assets/api/Category.js'
import apiPayment from './assets/api/Payment.js'
import apiCampaign from './assets/api/Campaign.js'
import apiReport from './assets/api/Report.js'
import apiBanner from './assets/api/Banner.js'
import apiMenuOutOfStock from './assets/api/MenuOutOfStock.js'
import apiNotification from './assets/api/Notification.js'
import { THE_GIVE_DATA_WAS_INVALID } from './utils/constants/Users.js'
import apiAudit from './assets/api/Audit.js'
import apiGiftcard from './assets/api/Giftcard.js'
import apiEarningFramework from './assets/api/EarningFramework.js'

Vue.axios.defaults.baseURL = process.env.host + '/' + process.env.version
Vue.axios.defaults.headers.common['Lang'] = 'en'

axios.interceptors.request.use(
  success => {
    delete axios.defaults.headers.common['x-user-email']
    main.$Progress.start()
    return success
  },
  error => {
    main.$Progress.fail()
    main.$toastr.error($t(error.response.data.message), main.$t('message.error'), {})
    return Promise.reject(error)
  }
)
axios.interceptors.response.use(
  success => {
    main.$Progress.finish()
    return success
  },
  error => {
    main.$bus.$emit('loading', 'none')
    const message = main._.get(error, 'response.data.error.message', '')

    // high priority authentication or authorization logic here
    if (['token.invalid', 'token.not_found', 'token.no_longer_effective'].includes(message)) {
      main.$Progress.fail()
      //Show toast when token is expired
      main.$bus.$emit('login_page', ['token.no_longer_effective'].includes(message) ? message : null)
      return
    }

    // applying for particular oos module
    if (error.response.data.errors !== undefined) {
      main.$Progress.finish()
      return Promise.reject(error)
    }

    // coupon logic error
    let couponErrorList = [
      "CP-GMS-01",
      "CP-GMS-02",
      "CP-GMS-04",
      "CP-GMS-05",
      "CP-GMS-06",
      "CP-GMS-07",
      "CP-GMS-08",
      "CP-GMS-09"
    ]
    if (couponErrorList.includes(error.response.data.error.code) ||
      main._.has(error, 'response.data.error.data.group_items') || main._.has(error, 'response.data.error.data.groups')) {
      return Promise.reject(error)
    }

    // rest of system error here
    if (message === 'user.email_not_found' || error.response.data.error.data === 'topping_rule_mapping.not_found') {
      main.$Progress.finish()
    } else {
      main.$Progress.fail()
      if (message.toLowerCase() === THE_GIVE_DATA_WAS_INVALID) {
        const errorMsgs = main._.get(error, 'response.data.error.data', {})
        let errorMsg = ''
        for (const key in errorMsgs) {
          errorMsg = errorMsgs[key] ? (main._.isArray(errorMsgs[key]) ? errorMsgs[key][0] : errorMsgs[key]) : ''
        }
        main.$toastr.error(main.$t(`message.${errorMsg.toLowerCase().replaceAll(' ', '_').replaceAll('.', '')}`), main.$t('message.error'), {})
      } else {
        main.$toastr.error(main.$t(message), main.$t('message.error'), {})
      }
    }
    return Promise.reject(error)
  }
)

axios.outlet = apiOutlet
axios.menu = apiMenu
axios.tenant = apiTenant
axios.coupon = apiCoupon
axios.order = apiOrder
axios.user = apiUser
axios.customer = apiCustomer
axios.category = apiCategory
axios.payment = apiPayment
axios.campaign = apiCampaign
axios.report = apiReport
axios.banner = apiBanner
axios.menuOutOfStock = apiMenuOutOfStock
axios.audit = apiAudit
axios.notification = apiNotification
axios.giftcard = apiGiftcard
axios.earningFramework = apiEarningFramework

export default axios



// WEBPACK FOOTER //
// ./src/axios.js